import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { paths } from '@app/constants';
import { Namespace, usePermissions } from '@data';
import { AntdSpace, AntdTypography, Button } from '@ui/components';

const { Title, Text } = AntdTypography;

export const Header = () => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const { IS_REVIEWER } = usePermissions();

  return (
    <header
      style={{ borderBottom: '1px solid #F0F0F0' }}
      className="p-4 flex items-center justify-between"
    >
      <Title className="m-0 text-2xl font-medium" data-testid="trials-library-title">
        {t('trials_library.title')}
      </Title>
      {!IS_REVIEWER && (
        <AntdSpace>
          <Text className="text-base-500">{t('trial_recruitment.missing_trial')}? </Text>
          <Link
            to={`/${paths.app}/${paths.trial_recruitment}/${paths.requests}`}
            state={{ openCreateTrialForm: true }}
          >
            <Button icon={<PlusCircleOutlined />} type="primary" data-testid="create-trial-button">
              {t('trial_recruitment.create_trial')}
            </Button>
          </Link>
        </AntdSpace>
      )}
    </header>
  );
};
